import { Icon } from "@certn/cascadia-react";
import { CardState, CardConfiguration } from "./types";

export function valuesMatch(
  optionValue: unknown,
  argumentValue: unknown
): boolean {
  if (argumentValue === undefined || argumentValue === null) {
    return false;
  }

  if (Array.isArray(optionValue) && Array.isArray(argumentValue)) {
    if (optionValue.length !== argumentValue.length) {
      return false;
    }
    return optionValue.every(
      (value, index) => String(value) === String(argumentValue[index])
    );
  }

  if (Array.isArray(optionValue)) {
    return optionValue.some((value) => String(value) === String(argumentValue));
  }

  if (Array.isArray(argumentValue)) {
    return argumentValue.some((value) => String(value) === String(optionValue));
  }

  return String(optionValue) === String(argumentValue);
}

export const configurations: Record<CardState, CardConfiguration> = {
  default: {
    icon: (testID) => (
      <Icon
        type="standard"
        name="add"
        size="space-5"
        color="icon-base"
        testID={`${testID}-add-icon`}
      />
    ),
    iconBackground: "background-accent-neutral-weak",
    cardBorderSize: "1px",
    cardBorderColor: "border-base",
    cardHasHover: true,
    cardHasPointer: true,
  },
  disabled: {
    icon: (testID) => (
      <Icon
        type="standard"
        name="lock"
        size="space-5"
        color="icon-base"
        testID={`${testID}-lock-icon`}
      />
    ),
    iconBackground: "background-accent-neutral-weak",
    cardBorderSize: "1px",
    cardBorderColor: "border-input-disabled",
    cardHasHover: false,
    cardHasPointer: false,
  },
  selected: {
    icon: (testID) => (
      <Icon
        type="standard"
        name="check"
        size="space-5"
        color="icon-inverse"
        testID={`${testID}-check-icon`}
      />
    ),
    iconBackground: "background-accent-neutral-strong",
    cardBorderSize: "2px",
    cardBorderColor: "border-input-active",
    cardHasHover: false,
    cardHasPointer: true,
  },
  "selected-disabled": {
    icon: (testID) => (
      <Icon
        type="standard"
        name="check"
        size="space-5"
        color="icon-inverse"
        testID={`${testID}-check-icon`}
      />
    ),
    iconBackground: "background-selected-medium",
    cardBorderSize: "2px",
    cardBorderColor: "border-input-disabled",
    cardHasHover: false,
    cardHasPointer: false,
  },
};
